// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"e96c99df","352":"333c0cfb","453":"670e15c7","484":"702475c6","626":"54baaf78","740":"7bd2b21b","765":"3fdfab94","806":"2b090136"}[chunkId] + ".chunk.js";
};